/* CloudFortifiedAppBadge.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _12 = "._w1ap1osq._w1ap1osq{width:100%}";
const _11 = "._1kba1h6o._1kba1h6o{align-items:center}";
const _10 = "._if291txw._if291txw{display:flex}";
const _9 = "._kkk2n7od{all:unset}";
const _8 = "._1wyboqnp{font-size:.75rem}";
const _7 = "._k48pni7l{font-weight:600}";
const _6 = "._1ccqt94y{word-spacing:1px}";
const _5 = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const _4 = "._18u0v77o{margin-left:var(--ds-space-025,2px)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EVENT_CONTAINER_CLOUD_FORTIFIED_TOOLTIP, LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { ExternalLinks } from '@atlassian/mpac-types';
import queryString from 'query-string';
import RichTooltip from '../../primitives/RichTooltip';
import CloudFortifiedAppIcon from '../CloudFortifiedAppIcon';
import CloudFortifiedAppTooltipV2 from './CloudFortifiedAppTooltipV2';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._18s8qssn{margin:var(--ds-space-100,8px) 0 0}";
const ANALYTICS_SUBJECT_ID_VIEW_MORE_LINK = 'viewMoreLink';
export const P = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "p",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18s8qssn _1e0c1txw _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  P.displayName = 'P';
}
const BadgeLabel = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5, _6, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18u0v77o _syaz1gjq _1ccqt94y _k48pni7l _1wyboqnp", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BadgeLabel.displayName = 'BadgeLabel';
}
const BadgeContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_kkk2n7od _if291txw _1kba1h6o _w1ap1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BadgeContainer.displayName = 'BadgeContainer';
}
export const CloudFortifiedAppBadgeSources = Object.freeze({
  AppListing: 'app-listing-badge',
  AppTile: 'app-tile-badge',
  InstallDialog: 'app-install-dialog'
});
export default function CloudFortifiedAppBadge(_ref4) {
  let {
    className,
    showLabel,
    source
  } = _ref4;
  const fireAnalyticsEvent = useAnalyticsEvents();
  if (!showLabel) {
    return /*#__PURE__*/_jsx(CloudFortifiedAppIcon, {
      className: className,
      label: "Cloud Fortified App badge"
    });
  }
  const stopEventPropagation = e => e.stopPropagation();
  const onViewDetailsClick = e => {
    fireAnalyticsEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_VIEW_MORE_LINK,
      attributes: {
        label: e.target.text,
        eventContainer: EVENT_CONTAINER_CLOUD_FORTIFIED_TOOLTIP
      }
    });
  };
  const faqPageLink = source ? queryString.stringifyUrl({
    url: ExternalLinks.cloudFortified.faq,
    query: {
      source
    }
  }) : ExternalLinks.cloudFortified.faq;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(RichTooltip, {
      content: /*#__PURE__*/_jsx(CloudFortifiedAppTooltipV2, {
        faqPageLink: faqPageLink,
        onViewDetailsClick: onViewDetailsClick
      }),
      children: /*#__PURE__*/_jsxs(BadgeContainer, {
        tabIndex: -1,
        className: className,
        onClick: stopEventPropagation,
        children: [/*#__PURE__*/_jsx(CloudFortifiedAppIcon, {
          label: "Cloud Fortified app badge"
        }), /*#__PURE__*/_jsx(BadgeLabel, {
          children: "CLOUD FORTIFIED"
        })]
      })
    })
  });
}